import { render } from "./ExpenseCategories.vue?vue&type=template&id=40acfe3a&scoped=true"
import script from "./ExpenseCategories.vue?vue&type=script&lang=js"
export * from "./ExpenseCategories.vue?vue&type=script&lang=js"

import "./ExpenseCategories.vue?vue&type=style&index=0&id=40acfe3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40acfe3a"]])

export default __exports__